import Autosuggest, { AutosuggestProps } from '../Autosuggest'

export type MultiSelectProps<Item> = Omit<AutosuggestProps<Item>, 'multiple'>

export function MultiSelect<Item extends { id: string }>(props: MultiSelectProps<Item>) {
  return <Autosuggest<Item> {...props} multiple />
}
